// @flow
import * as React from 'react';
import classNames from '@ta/common.classnames';
import { RadioGroupContext } from './RadioGroup';
import styles from './RadioButton.css';

type Props = {|
  /** Value for the input element */
  value: string,
  /** The component that is being used as the content for the label */
  label?: React.Node,
  /** Is button selected */
  selected: boolean,
  /** On select callback */
  onSelect?: string => void,
  /** Is button disabled */
  disabled?: boolean,
|};

/**
 * A component around a radio label/input pair.
 */
const RadioButton = ({ value, label, selected, onSelect, disabled = false }: Props) => {
  const groupName = React.useContext(RadioGroupContext);
  if (!groupName) {
    throw new Error('Error - RadioButton rendered outside of a RadioGroup.');
  }
  const onSelectCallback = React.useCallback(() => {
    if (onSelect) {
      onSelect(value);
    }
  }, [onSelect, value]);

  return (
    <label
      className={classNames(
        styles.label,
        { [styles.disabled]: disabled },
        { [styles.selected]: selected },
      )}
    >
      {label}
      <input
        type="radio"
        className={styles.radio}
        value={value}
        name={groupName}
        checked={selected}
        onChange={onSelectCallback}
        disabled={disabled}
      />
    </label>
  );
};

export default RadioButton;
